import axios from 'axios';
import { toast } from 'react-toastify';
import { nodeURL } from '../../configUrl';




export const registerAction = (authData)=>async(dispatch)=>{
    

    try {
        const {data} = await axios.post(`${nodeURL}/register`,authData);
dispatch({type:'REGISTER',payload:data})
toast.success(data.msg || 'Kayıt başarılı!', {
    position: 'top-right',
    autoClose: 7000,
  });
  

    } catch (error) {
        toast (error.response.data.msg, {
position:'top-right',
autoClose:5000,
        })
    }

}

export const loginAction = (authData)=>async(dispatch)=>{

    try {
        const {data} = await axios.post(`${nodeURL}/login`,authData);
dispatch({type:'LOGIN',payload:data})
window.location = '/'
console.log(data,"usersinfo");

    } catch (error) {
        toast (error.response.data.msg, {
            position:'top-right',
            autoClose:5000,
                    })
    }

}
